"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Carousel: true
};
exports.default = exports.Carousel = void 0;
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireWildcard(require("react"));
var _chainFunction = _interopRequireDefault(require("chain-function"));
var _useResizeObserver = require("../utils/useResizeObserver");
var _IconButton = require("../IconButton/IconButton");
var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));
var _useSwipe = require("../utils/useSwipe");
var _isFunction = require("../utils/isFunction");
var _useCarousel = require("./_useCarousel");
var _Carousel = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Carousel.css") : void 0);
var _Carousel2 = require("./Carousel.types");
Object.keys(_Carousel2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Carousel2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Carousel2[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-carousel';
/**
 * The **Carousel** allows the user to browse through a set of items.
 * It can display one or several items at a time. From the displayed item or items,
 * the user can navigate to either the next or the previous item.
 * Optionally, a paging indicator displays the user’s current position inside the set of items.
 * The carousel control is best used for browsing through a set of images.
 * Viewing images one by one helps users to distinguish between different items.
 * In a comparison scenario, it can also be useful to display several items
 * side by side. The carousel is not limited to displaying images; it can contain controls.
 * */
const Carousel = exports.Carousel = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
      id,
      ariaLabel,
      className,
      direction,
      disableArrows,
      disableTransitions,
      slides: slidesProp,
      slideProps = {},
      pageSize = 1,
      autoRotate,
      autoRotateDuration,
      slideIndex,
      contentHeight: contentHeightProp,
      disablePageIndicator,
      pageIndicatorPlacement = 'bottom',
      arrowPlacement = 'page-indicator',
      carouselBackground = 'translucent',
      pageIndicatorBackground = 'solid',
      disablePageIndicatorBorder,
      previousButtonLabel,
      previousButtonProps,
      nextButtonLabel,
      nextButtonProps,
      floatingControls,
      verticalArrows,
      noWrap,
      stepSize: stepSizeProp = 0,
      customPageIndicator,
      slideAriaLabel,
      pageIndicatorText
    } = props,
    otherSectionProps = __rest(props, ["id", "ariaLabel", "className", "direction", "disableArrows", "disableTransitions", "slides", "slideProps", "pageSize", "autoRotate", "autoRotateDuration", "slideIndex", "contentHeight", "disablePageIndicator", "pageIndicatorPlacement", "arrowPlacement", "carouselBackground", "pageIndicatorBackground", "disablePageIndicatorBorder", "previousButtonLabel", "previousButtonProps", "nextButtonLabel", "nextButtonProps", "floatingControls", "verticalArrows", "noWrap", "stepSize", "customPageIndicator", "slideAriaLabel", "pageIndicatorText"]);
  const classnames = _bind.default.bind(_Carousel.default);
  const [freezeTransition, setFreezeTransition] = (0, _react.useState)(false);
  const contentGenerateId = (0, _useUniqueId.default)();
  const contentRef = (0, _react.useRef)(null);
  const contentId = id || contentGenerateId;
  let freezeTransitionTimer;
  const {
    width: contentWidth,
    height: contentCtrHeight
  } = (0, _useResizeObserver.useResizeObserver)({
    targetRef: contentRef,
    onResize: () => {
      setFreezeTransition(true);
      if (freezeTransitionTimer) {
        clearTimeout(freezeTransitionTimer);
      }
      // we need to disable the CSS transitions
      // from occurring while resizing so we freeze it
      // for a short time.
      freezeTransitionTimer = setTimeout(() => {
        setFreezeTransition(false);
      }, 10);
    }
  });
  const slides = (slidesProp === null || slidesProp === void 0 ? void 0 : slidesProp.slice) ? slidesProp :
  // eslint-disable-next-line react/jsx-no-useless-fragment
  Array(slidesProp.length).fill(/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null));
  const stepSize = direction !== 'vertical' ? stepSizeProp : 0;
  const carouselState = (0, _useCarousel.useCarousel)({
    pageSize,
    slides,
    autoRotate,
    autoRotateDuration,
    slideIndex,
    stepSize,
    noWrap
  });
  const {
    currentPageIndex,
    pageCount,
    prevPage,
    nextPage,
    isSlideOnPageFn,
    isOnFirstPage,
    isOnLastPage
  } = carouselState;
  let swipeProps = {
    onRightSwipe: prevPage,
    onLeftSwipe: nextPage
  };
  if (direction === 'vertical') {
    swipeProps = {
      onUpSwipe: nextPage,
      onDownSwipe: prevPage
    };
  }
  (0, _useSwipe.useSwipe)(Object.assign({
    ref: contentRef
  }, swipeProps));
  const arrowButton = iconButtonprops => {
    var _a;
    return !disableArrows && (/*#__PURE__*/_react.default.createElement(_IconButton.IconButton, Object.assign({
      type: "secondary"
    }, iconButtonprops, {
      iconProps: Object.assign({
        forceSize: 'sm'
      }, iconButtonprops === null || iconButtonprops === void 0 ? void 0 : iconButtonprops.iconProps),
      className: classnames(iconButtonprops === null || iconButtonprops === void 0 ? void 0 : iconButtonprops.className, `${CSS_BLOCK}__arrow-button`),
      innerProps: Object.assign(Object.assign({}, iconButtonprops === null || iconButtonprops === void 0 ? void 0 : iconButtonprops.innerProps), {
        className: classnames((_a = iconButtonprops === null || iconButtonprops === void 0 ? void 0 : iconButtonprops.innerProps) === null || _a === void 0 ? void 0 : _a.className, `${CSS_BLOCK}__inner`, {
          [`${CSS_BLOCK}__inner--content`]: arrowPlacement === 'content'
        })
      })
    })));
  };
  const getDirectionProp = () => {
    switch (pageIndicatorPlacement) {
      case 'start':
      case 'end':
        return 'vertical';
      case 'top':
      case 'bottom':
      default:
        return 'horizontal';
    }
  };
  const directionProp = direction || getDirectionProp();
  const previousButton = arrowButton(Object.assign(Object.assign({
    iconName: directionProp === 'vertical' ? 'navigation-up-arrow' : 'navigation-left-arrow',
    'aria-controls': contentId
  }, previousButtonProps), {
    onClick: (previousButtonProps === null || previousButtonProps === void 0 ? void 0 : previousButtonProps.onClick) ? (0, _chainFunction.default)(prevPage, previousButtonProps.onClick) : prevPage,
    ariaLabel: previousButtonLabel,
    disabled: (nextButtonProps === null || nextButtonProps === void 0 ? void 0 : nextButtonProps.disabled) || noWrap && isOnFirstPage,
    'data-nui-widgets': 'carousel-previous-button'
  }));
  const nextButton = arrowButton(Object.assign(Object.assign({
    iconName: directionProp === 'vertical' ? 'navigation-down-arrow' : 'navigation-right-arrow',
    'aria-controls': contentId
  }, nextButtonProps), {
    onClick: (nextButtonProps === null || nextButtonProps === void 0 ? void 0 : nextButtonProps.onClick) ? (0, _chainFunction.default)(nextPage, nextButtonProps.onClick) : nextPage,
    ariaLabel: nextButtonLabel,
    disabled: (nextButtonProps === null || nextButtonProps === void 0 ? void 0 : nextButtonProps.disabled) || noWrap && isOnLastPage,
    'data-nui-widgets': 'carousel-next-button'
  }));
  const getControlsDirection = () => {
    switch (pageIndicatorPlacement) {
      case 'start':
      case 'end':
        return 'column';
      case 'top':
      case 'bottom':
      default:
        return 'row';
    }
  };
  const pageIndicator = !disablePageIndicator && (/*#__PURE__*/_react.default.createElement("div", {
    className: classnames(`${CSS_BLOCK}__page-indicators`),
    style: {
      flexDirection: getControlsDirection()
    }
  }, Array.from({
    length: pageCount
  }, (_, index) => (/*#__PURE__*/_react.default.createElement("div", {
    key: index,
    "data-nui-widgets": "carousel-page-indicator",
    "data-testid": "carousel-page-indicator",
    className: classnames(`${CSS_BLOCK}__indicator-container`),
    style: {
      flexBasis: `${100 / pageCount}%`
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classnames(`${CSS_BLOCK}__indicator-dot`, {
      [`${CSS_BLOCK}__indicator-dot--current`]: !stepSize ? index === currentPageIndex : currentPageIndex + pageSize > index && index >= currentPageIndex
    })
  }))))));
  const indicatorText = pageIndicatorText === null || pageIndicatorText === void 0 ? void 0 : pageIndicatorText(carouselState);
  const pageIndicatorAndText = (0, _isFunction.isFunction)(customPageIndicator) ? customPageIndicator(carouselState) : (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, pageIndicator, indicatorText && (/*#__PURE__*/_react.default.createElement("div", {
    className: classnames(`${CSS_BLOCK}__page-indicators-text`, {
      [`${CSS_BLOCK}__page-indicators-text--floating`]: !!floatingControls
    })
  }, indicatorText))));
  const defaultArrowPlacement = arrowPlacement === 'page-indicator' || !arrowPlacement;
  const defaultpageIndicatorPlacement = pageIndicatorPlacement === 'bottom' || !pageIndicatorPlacement;
  const disableDefaultControlsContainer = disablePageIndicator && !indicatorText && (disableArrows || arrowPlacement === 'content') || floatingControls;
  const defaultControlsContainer = disableDefaultControlsContainer ? null : (/*#__PURE__*/_react.default.createElement("div", {
    "data-nui-widgets": "carousel-controls",
    className: classnames(`${CSS_BLOCK}__page-controls-container`, {
      [`${CSS_BLOCK}__page-controls-container--${pageIndicatorBackground}`]: pageIndicatorBackground === 'solid' || pageIndicatorBackground === 'translucent',
      [`${CSS_BLOCK}__page-controls-container--${pageIndicatorPlacement}`]: pageIndicatorPlacement !== undefined && !disablePageIndicatorBorder
    }),
    style: {
      flexDirection: getControlsDirection()
    }
  }, defaultArrowPlacement && previousButton, /*#__PURE__*/_react.default.createElement("div", {
    className: classnames(`${CSS_BLOCK}__page-indicators-container`)
  }, pageIndicatorAndText), defaultArrowPlacement && nextButton));
  const transitionStyles = disableTransitions || freezeTransition ? {} : {
    transition: 'transform 0.5s ease'
  };
  const contentHeight = contentHeightProp;
  const directionStyles = directionProp === 'vertical' ? {
    gridTemplateColumns: `repeat(${pageSize}, 1fr)`,
    height: `calc(${contentHeight} * ${pageCount})`,
    transform: `translateY(-${contentCtrHeight * currentPageIndex}px)`
  } : {
    width: `${contentWidth * slides.length / pageSize}px`,
    transform: `translateX(-${!stepSize ? contentWidth * currentPageIndex : contentWidth * currentPageIndex / pageSize}px)`
  };
  const containerHeight = contentHeight || `${contentCtrHeight}px`;
  const contentContainerStyles = directionProp === 'vertical' ? {
    height: containerHeight
  } : {};
  const getFlexDirection = () => {
    switch (pageIndicatorPlacement) {
      case 'top':
        return 'column-reverse';
      case 'start':
        return 'row-reverse';
      case 'end':
        return 'row';
      case 'bottom':
      default:
        return 'column';
    }
  };
  const getFloatingControlsFlexDirection = () => {
    switch (pageIndicatorPlacement) {
      case 'top':
        return 'column-reverse';
      case 'start':
        return 'row-reverse';
      case 'end':
        return 'row';
      case 'bottom':
      default:
        return 'column';
    }
  };
  const getArrowsStyles = () => {
    if (verticalArrows) {
      return {
        height: contentCtrHeight
      };
    }
    return {
      top: `${contentCtrHeight / 2 - 18}px`
    };
  };
  const floatingControlsContainer = floatingControls && (/*#__PURE__*/_react.default.createElement("div", {
    className: classnames(`${CSS_BLOCK}__content-controls-container`),
    style: {
      width: contentWidth
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classnames(`${CSS_BLOCK}__content-direction`),
    style: {
      height: contentCtrHeight || containerHeight,
      flexDirection: getFloatingControlsFlexDirection()
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classnames(`${CSS_BLOCK}__content-arrows`, {
      [`${CSS_BLOCK}__content-arrows--vertical`]: verticalArrows
    })
  }, !defaultArrowPlacement && (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, previousButton, nextButton))), !defaultArrowPlacement && !indicatorText && disablePageIndicator ? null : (/*#__PURE__*/_react.default.createElement("div", {
    className: classnames(`${CSS_BLOCK}__content-floating-controls-container`),
    style: {
      flexDirection: getControlsDirection(),
      top: defaultpageIndicatorPlacement ? `${contentCtrHeight - 58}px` : '2px'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      flexDirection: getControlsDirection()
    },
    className: classnames(`${CSS_BLOCK}__content-floating-controls`)
  }, defaultArrowPlacement && previousButton, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      flexDirection: getControlsDirection()
    },
    className: classnames(`${CSS_BLOCK}__content-floating-indicators`)
  }, pageIndicatorAndText), defaultArrowPlacement && nextButton))))));
  return /*#__PURE__*/_react.default.createElement("section", Object.assign({}, otherSectionProps, {
    "aria-label": ariaLabel,
    ref: ref,
    className: classnames(CSS_BLOCK, className),
    "aria-roledescription": "carousel",
    style: !floatingControls ? Object.assign({
      flexDirection: getFlexDirection()
    }, otherSectionProps === null || otherSectionProps === void 0 ? void 0 : otherSectionProps.style) : otherSectionProps === null || otherSectionProps === void 0 ? void 0 : otherSectionProps.style
  }), /*#__PURE__*/_react.default.createElement("div", {
    ref: contentRef,
    id: contentId,
    "aria-live": autoRotate ? 'off' : 'polite',
    className: classnames(`${CSS_BLOCK}__content-container`, {
      [`${CSS_BLOCK}__content-container--${carouselBackground}`]: carouselBackground === 'solid' || carouselBackground === 'translucent'
    }),
    style: contentContainerStyles
  }, arrowPlacement === 'content' && !floatingControls && (/*#__PURE__*/_react.default.createElement("div", {
    className: classnames(`${CSS_BLOCK}__content-controls-container`),
    style: {
      width: contentWidth
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classnames(`${CSS_BLOCK}__content-controls`, {
      [`${CSS_BLOCK}__content-controls--vertical`]: verticalArrows
    }),
    style: getArrowsStyles()
  }, previousButton, nextButton))), floatingControlsContainer, /*#__PURE__*/_react.default.createElement("div", {
    className: classnames({
      [`${CSS_BLOCK}__horizontal-content`]: directionProp !== 'vertical',
      [`${CSS_BLOCK}__vertical-content`]: directionProp === 'vertical'
    }),
    style: Object.assign(Object.assign({
      height: contentHeight
    }, transitionStyles), directionStyles)
  }, _react.default.Children.map(slides, (child, index) => {
    const isSlideOnPage = isSlideOnPageFn(index);
    const slidePropsValue = (0, _isFunction.isFunction)(slideProps) ? slideProps(Object.assign({
      index,
      slide: child,
      isSlideOnPage
    }, carouselState)) : slideProps;
    const slidePropsEx = Object.assign({
      'aria-hidden': !isSlideOnPage
    }, slidePropsValue);
    const slideAriaLabelText = slideAriaLabel === null || slideAriaLabel === void 0 ? void 0 : slideAriaLabel(Object.assign({
      index,
      slide: child,
      isSlideOnPage
    }, carouselState));
    const allSlideProps = Object.assign(Object.assign({
      role: 'group'
    }, slidePropsEx), {
      className: classnames(`${CSS_BLOCK}__slide`, slidePropsEx === null || slidePropsEx === void 0 ? void 0 : slidePropsEx.className),
      style: Object.assign(Object.assign({}, slidePropsEx === null || slidePropsEx === void 0 ? void 0 : slidePropsEx.style), {
        width: `${contentWidth / pageSize}px`
      })
    });
    return /*#__PURE__*/_react.default.createElement("div", Object.assign({}, allSlideProps), /*#__PURE__*/_react.default.createElement("span", {
      "data-testid": "slide-arialabel-text",
      className: classnames(`${CSS_BLOCK}__screen-reader-only`)
    }, slideAriaLabelText), typeof (slidesProp === null || slidesProp === void 0 ? void 0 : slidesProp.content) === 'function' ? slidesProp.content(Object.assign(Object.assign(Object.assign({}, allSlideProps), {
      index,
      slide: child,
      isSlideOnPage
    }), carouselState)) : child);
  }))), defaultControlsContainer);
});
Carousel.displayName = 'Carousel';
var _default = exports.default = Carousel;